export default class UtilTracking{
    constructor(){
        
        document.addEventListener("click", (e) =>{
           
            const target = e.target.closest('[data-dstapi-click]');
            if(target)
                this.triggerTracking(target);
        
        });
        
    }

    triggerTracking(elem){
       
        var trackingObject = this.getTrackingObject(elem);
        
        if(window.dataLayer){
            window.dataLayer.push(trackingObject);
        }else{
            console.log("window.datalayer", trackingObject);
        }
        
    }

    getTrackingObject(elem){

        var oOptions = {};
        for (var k in elem.dataset) {           
            if(!elem.dataset.hasOwnProperty(k))
                continue;
        
            if (k.indexOf('dstapi') < 0) 
                continue;
            
            let value = elem.dataset[k];
            if(!value)
                continue;

            oOptions[k.replace('dstapi', '').toLowerCase()] = value;
        }

        return oOptions;
    }
}